<template lang="html">
    <section class="basket-order" v-if="placeOrderRights">
        <loader :loading="loading"></loader>
        <div class="basket-order-nbItems">{{ datasListBaskets.nbItems }} {{ $t("basket.items") }}</div>
        <div class="basket-order-finalPrice">
            <span class="subTitle">{{ $t("basket.subTotal") }}</span>
            <span class="finalPrice" v-if="datasListBaskets.currency.shortName">
                {{
                    displayRealPrice(datasListBaskets.finalPrice, getBasket.priceShown)
                        | CurrencyCustomPipe("en-US", datasListBaskets.currency.shortName)
                }}
            </span>
        </div>
        <div class="basket-order-detail">
            <p>{{ $t("basket.noteBasket") }}</p>
        </div>
        <div class="basket-order-action">
            <button class="btn" @click="validateBasket();">{{ $t("basket.btnOrder") }}</button>
        </div>
    </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'
import loader from '../loader/loader'


export default {
    name: 'basket-order',
    props: ['datasListBaskets'],
    components: {loader},
    data() {
        return {
            loading: false
        }
    },
    computed: {
        ...mapGetters("basket/details", {
            getBasket: "getBasket"
        }),
        placeOrderRights () {
            return this.hasClientAccess('orders_manager',...(this.AccessUser.CONTRIBUTE));
        },
    },
    methods: {
        ...mapActions("basket/details", {
            placeOrder: "placeOrder"
        }),
        ...mapActions("basket", {
            populateBasketList: "list/populateBasketList",
        }),
        async validateBasket() {
            this.loading = true
            try {
                let dataTest = this.getBasket.items.filter(v => {
                    if (v.quantity <= 0) return true
                    if (v.unit <= 0) return true
                })
                if (dataTest && dataTest.length > 0) {
                    this.$swal({
                        text: this.$t("basket.placeOrderError"),
                        type: "error",
                        confirmButtonText: "OK",
                        confirmButtonColor: "red",
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    });
                } else {
                    const res = await this.placeOrder(this.getBasket.id);
                    this.populateBasketList();
                    this.$router.replace({name: 'MyOrder', params: {id: res.id}})
                }
            }
            catch (err) {
                this.$swal({
                    text: this.$t("basket.placeOrderError"),
                    type: "error",
                    confirmButtonText: "OK",
                    confirmButtonColor: "red",
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });
                console.error(err)
            }
            finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.basket-order {
    padding: 10px;
    &-nbItems {
        font-weight: bold;
        margin-bottom: 20px;
    }
    &-finalPrice {
        font-weight: bold;
        margin-bottom: 10px;
        & div {
            display: inline-block;
        }
        & .finalPrice {
            float: right;
        }
    }
    &-detail {
        p {
            font-size: 12px;
            margin: 0;
        }
    }
    &-action {
        margin: 15px 0 5px 0;
        text-align: center;
        button {
            background-color: $color2;
            border-radius: 0;
            border: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// BasketOrder.vue?8d523124